<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title1"><h1 class="title"><strong class="b">ACKNOWLEDGMENTS</strong></h1>
<p class="p"><span>The completion of this book has benefited from, and indeed has been made possible by the assistance, cooperation, and encouragement of many people. I have benefited tremendously from the comments and reminiscences of those who have reviewed my previous book, <em class="i">Grand Rapids in Vintage Postcards: 1890—1940,</em> and I am grateful for their assistance. As was the case before, my friends Ron Carowitz and Milt Ehlert have strongly encouraged this effort and have provided me with useful counsel and advice. Ron Carowitz, himself a recognized authority on Grand Rapids postcard history, generously arranged for my use of the excellent and probably most complete assemblage of the Mr. Rover cards in existence in the collection of the late Justin Tiery. I am grateful to Justin’s widow, Ruth Tiery, for her generous permission to publish this part of her late husband’s fabulous and important collection.</span></p>
<p class="p-indent"><span>The staff and resources of the Grand Rapids Public Library, Special Collections Section, and especially my friend, Christine Byron, have again, as always, been most helpful. Charles and Patricia Bloom generously provided me with several of the cards that appear in the book, as well as their own reminiscences.</span></p>
<p class="p-indent"><span>Once again, my work on this project has benefited greatly from the counsel and advice of my brother-in-law, Paul J. LaPorte. The staff of my publisher, and particularly Anna Wilson, have been most helpful and pleasant to work with.</span></p>
<p class="p-indent"><span>All of these generous contributions, however, pale in comparison to the encouragement and support that has been ceaselessly provided to me by my wife, Debra, and daughter, Sarah. Without their kindness and support, this never would have happened.</span></p></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439616864_ack01.vue?36283062